/**
 * Pega duas coordenadas e mostra informações do percurso entre elas, velocidade
 * média tempo gasto, distância percorrida.
 *
 * @author Mozart Diniz Date: 20/12/2012 Time: 18:00
 */
import { createRoot } from 'react-dom/client';
import StopStatusCaption from 'react/components/Maps/StopStatusCaption';
import { STOP_STATUS } from 'react/utils/stopUtils';
import { getMostRecentCoordinate } from 'react/utils/coordinateUtils';
import { DefaultRequest } from 'scripts/api';
import EquipmentStatusCaption from 'react/components/RouteDetails/EquipmentStatusCaption';
const loadingImage = require('static/images/general/loading_blue.svg');

Greenmile.RouteDetail = Greenmile.RouteDetail || {};
Greenmile.RouteDetail.Util = Greenmile.RouteDetail.Util || {};

Greenmile.RouteDetail.Util.addMarkerToMap = function (lat, longit, address, routeId, kind) {

    this.routeDeltail = Monet.Session.RouteDetail.screensList[routeId];
    this.map = null;
    this.marker = null;
    this.icon = null;

    if (typeof (this.routeDeltail) !== undefined) {

        this.map = this.routeDeltail.map;

        this.icon = L.icon({
            iconUrl: require('static/images/map/markers/generic_marker_blue.png'),
            iconSize: [15, 26],
            iconAnchor: [7.5, 26],
            popupAnchor: [-10, -40]
        });

        this.marker = L.marker([lat, longit], {
            icon: this.icon,
            zIndexOffset: 0
        });

        this.marker.kind = kind;

        this.marker.addTo(this.map).bindPopup(address).openPopup();

        this.map.setZoom(14);

        this.map.panTo([lat, longit]);

        return true;
    }

    return false;

};

Greenmile.RouteDetail.Util.addTruckMarkerToMap = function (coordinate, equipment, sourceData, equipmentType) {
  if (coordinate) {
    const position = coordinate.get('position');
    const iconUrl = equipmentType === 'SECONDARY_EQUIPMENT' ? require(
            'static/images/map/markers/pin_' +
              equipment?.coordinatesColor.substring(1) +
              '.svg'
          ) : require('static/images/map/markers/marker_truck.png');

    const map = sourceData.map;
    equipment.idOfObject = equipment.idOfObject || equipment.id;

    Greenmile.RouteDetail.Util.removeTruckMarkerFromMap(map, equipment.idOfObject);

    const latlng = [position.latitude, position.longitude];
    const myIcon = L.icon({
        iconUrl: iconUrl,
        iconSize: [22, 22],
        iconAnchor: [10, 11],
        popupAnchor: [-6, 0]
    });
    const marker = L.marker(latlng, {
        icon: myIcon,
        zIndexOffset: 99999
    });

    equipment.speedKmh = coordinate.attributes.speedKmh;

    if (equipmentType === 'PRINCIPAL_EQUIPMENT') {
        marker.kind = 'EQUIPMENT';

        sourceData.player.marker = marker;

        sourceData.player.marker.coordinates = coordinate.attributes;
        sourceData.player.marker.coordinates.date = coordinate.attributes.date;

    } else {
        marker.kind = equipmentType;
    }

    marker.equipmentId = equipment.idOfObject;
    marker.equipmentKey = equipment.key;
    marker.coordinates = coordinate.attributes;

    Greenmile.RouteDetail.Util.addClickEventToMarker(sourceData, marker, equipment, map);

    marker.addTo(map);
  }
};

Greenmile.RouteDetail.Util.checkTruckerOnMap = function (markerTruck, map) {
    var markers, find = false;
    markers = map._layers;

    for (var key in markers) {
        if (markers[key] && markers[key].kind && markers[key].kind.toString() === markerTruck.kind.toString()) {
            find = true;
        }
    }

    if (!find) {
        markerTruck.addTo(map);
    }
};

Greenmile.RouteDetail.Util.setTruckPosition = function (latlng, routeId) {

    var screen = Monet.Session.RouteDetail.screensList[routeId];

    if (screen.player.marker && latlng[0] && latlng[1]) {
        screen.player.marker.setLatLng(latlng);
    }

};

Greenmile.RouteDetail.Util.removeTruckMarkerFromMap = function (map, equipmentId) {

    for (var i in map._layers) {

        if (typeof map._layers[i].kind !== "undefined") {

            var mapEquipmentId = map._layers[i].equipmentId;

            if (mapEquipmentId && mapEquipmentId.toString() === equipmentId.toString()) {

                map.removeLayer(map._layers[i]);

            }
        }
    }
};

Greenmile.RouteDetail.Util.EquipmentOrRouteSucess = function (screenList, marker, equipment, data, popup) {
    var renderedTemplate;
    data.idIsLink = false;

    var markerCoordinate = {};
    var formattedSpeed;
    var speed = equipment.speedKmh;
    var index = 0;
    var coordinates = null;

    if (marker.coordinates) {
        markerCoordinate = marker.coordinates;
    }
    markerCoordinate.equipmentKey = equipment.equipmentKey || equipment.key;

    if (marker.kind === 'EQUIPMENT') {
        index = screenList.player.playerIndex;
        coordinates = screenList.coordinates;
    }

    if (index) {
      const model = coordinates.at(index);
      if (model) {
        const { attributes: { speedKmh, date } } = model;
        speed = speedKmh;
        markerCoordinate.date = date;
      }
    }

    formattedSpeed = new Monet.Format.MILES_OR_KM(speed).formatToKmOrMilesPerHour().getValue();

    if (!data.equipment) {
        data.equipment = {};
        data.equipment.id = equipment.idOfObject;
    }

    const driversInfo = [];

    if (data?.driversInfo) {
      for (const serverDriverInfo of data.driversInfo) {
        const driver = { name: serverDriverInfo.name };
        const phones = serverDriverInfo.phoneInfos;

        let strPhones = '';

        for (const phoneInfo of phones) {
          strPhones += phoneInfo.phone + ' / ';
        }

        strPhones = strPhones.slice(0, strPhones.length - 3);

        driver.phones = strPhones;
        driversInfo.push(driver);
      }

    }

    if (data.totalStops) {

        data.delivered = (data.totalArrivesStops / data.totalStops) * 100 + '%';
        data.backLater = (data.totalRedeliveryStops / data.totalStops) * 100 + '%';
        data.returnStops = (data.totalCancelStops / data.totalStops) * 100 + '%';
        data.deliveryProgress = data.totalArrivesStops + data.totalRedeliveryStops + data.totalCancelStops + '/' + data.totalStops + ' (' + parseInt(((data.totalArrivesStops + data.totalRedeliveryStops + data.totalCancelStops) / data.totalStops) * 100, 10) + '%)';

    } else if (data.totalStops === 0) {

        data.delivered = 0;
        data.backLater = 0;
        data.returnStops = 0;
        data.deliveryProgress = '0/0 (0%)';

    }

    renderedTemplate = Greenmile.Templates.getLeafletPopUp({
        markerEl: marker,
        marker: markerCoordinate,
        request: data,
        velocityKm: formattedSpeed,
        driversInfo: driversInfo,
        telematicList: []
    });
    popup.setContent(renderedTemplate);
};

Greenmile.RouteDetail.Util.addClickEventToMarker = function (sourceData, marker, equipment, map) {

  const popup = L.popup({
    offset: new L.Point(35, 5),
    autoPan: true,
    autoPanPaddingTopLeft: new L.Point(100, 100),
    minWidth: 371,
    maxWidth: 500,
    minHeight: 230
  });
    const openPopupLoading = () => {
      
      const contentLoading = `
        <div style="height:350px;width: 371px;">
          <img src="${loadingImage}" width="50" style="margin-left: -25px; margin-top: -25px; left: 50%; top: 50%; opacity: 0.5; position:absolute;">
        </div>
      `;
      popup.setLatLng(marker.getLatLng()).setContent(contentLoading).openOn(map);
    };

    marker.on("click", function (sourceData) {

        var screenList = sourceData;

        return function () {
            openPopupLoading();

            const equipmentId = equipment.idOfObject || equipment.id;

            if (equipmentId) {
                const { equipmentAssignments } = screenList.model || {};
                const isPrimaryEquipment = screenList.route && equipmentAssignments && equipmentAssignments.find((assignment) => (
                    assignment.equipment.id == equipmentId && assignment.principal
                ));
                if (isPrimaryEquipment) {
                    const request = new DefaultRequest({
                        url: "Route/" + screenList.route + "/Status",
                        success: function(data) {
                            Greenmile.RouteDetail.Util.EquipmentOrRouteSucess(
                              screenList,
                              marker,
                              equipment,
                              data,
                              popup
                            );
                        }
                    });
                    request.send();
                } else {
                    const request = new DefaultRequest({
                        url: "Equipment/" + equipmentId + "/RouteStatus",
                        success: function(data) {
                            Greenmile.RouteDetail.Util.EquipmentOrRouteSucess(
                              screenList,
                              marker,
                              equipment,
                              data,
                              popup
                            );
                        }
                    });
                    request.send();
                }
            }

        };
    }(sourceData));
};

Greenmile.RouteDetail.Util.renderNumberedIconMarker = (
  {
    id,
    latitude,
    longitude,
    plannedSequenceNum,
    actualSequenceNum,
    redeliveryStop,
    kind,
    color
  }
) => {
  const numberComplement = (actualSequenceNum) ? `/${actualSequenceNum}` : '';
  const iconOptions = {
    color,
    content: `<strong>${plannedSequenceNum}</strong>${numberComplement}`,
    plot: !redeliveryStop?.id,
    statusClass: STOP_STATUS.PENDING,
    kind
  };

  const marker = L.marker([latitude, longitude], {
    icon: new Greenmile.RouteDetail.NumberedDivIcon(iconOptions),
    draggable: false,
    riseOnHover: true
  });
  marker.id = id;
  marker.kind = kind;

  return marker;
};

Greenmile.RouteDetail.Util.renderCaptions = (routeId, equipmentList) => {
  const container = document.querySelector(
    `#routeMaps_${routeId} .bottomBarContainer .status-legends-container`
  );

  const alreadyHasCaptions = container.querySelector('.equipment-stop');
  if (!alreadyHasCaptions) {
    const root = createRoot(container);
    root.render(
      <>
        <EquipmentStatusCaption equipmentList={equipmentList} />
        <StopStatusCaption />
      </>
    );
  }
};

Greenmile.RouteDetail.Util.renderPathFromPositionSources = (
  equipment,
  route,
  positionSources,
  activeLayers
) => {
  const screen = Monet.Session.RouteDetail.screensList[route.id];
  if (!screen || !equipment || !route || !positionSources) return;
  screen.equipments = screen.equipments || {};
  const equipmentSessionStore = screen.equipments[equipment.id] || {
    key: equipment.key,
    id: equipment.id,
    positionSources: []
  };
  const coordinatesFunctions = new Greenmile.Coordinates.GeneralFunctions(
    screen
  );
  const pathColors = ['#FF41A6', '#FF7D00'];
  const equipmentBelongsToRoute = route.equipmentAssignments?.some(
    (equipmentAssigned) =>
      equipmentAssigned?.equipment?.id.toString() === equipment.id.toString()
  );
  let lastCoordinateModel;
  let equipmentType
  equipmentSessionStore.positionSources = positionSources;
  screen.equipments[equipment.id] = equipmentSessionStore;

  
  const renderPath = (positionSource, index) => {
    const hasSourceInFilters = activeLayers?.find((layer) => layer.id === positionSource.id);
    const existsFilterToRoute = !!activeLayers;

    if (existsFilterToRoute && !hasSourceInFilters) return;

    const { coordinates } = positionSource.attributes;
    if (coordinates?.size) {
      const equipmentId = equipment.id;
      const colorIndex = index % pathColors.length;
      let color = pathColors[colorIndex];
      let kind = 'ACTUAL_ROUTE';

      if (!equipmentBelongsToRoute) {
        const colorIndex = screen.equipmentColorMapping?.[equipmentId];
        if (typeof colorIndex === 'number' && screen.routeColor?.[colorIndex]) {
          color = screen.routeColor[colorIndex];
        } else if (screen.equipments[scopeEquipment?.id]?.coordinatesColor) {
          color = screen.equipments[scopeEquipment.id].coordinatesColor;
        } else if (screen.routeColor?.[0]) {
          color = screen.routeColor[0];
        }
        kind = 'SECONDARY_ROUTE';
      }

      screen.equipments[equipmentId] = {
        ...screen.equipments[equipmentId],
        coordinatesColor: color
      };
      coordinatesFunctions.generateActualRouteInfo(
        screen.map,
        coordinates,
        {
          color: color,
          kind: kind,
          source: positionSource.attributes
        },
        equipment.id
      );
    }
  };

  if (equipmentBelongsToRoute) {
      const isEquipmentAssignedAndIsPrincipal =
    (
      route.equipmentAssignments?.filter(
        (equipmentAssigned) =>
          equipmentAssigned?.equipment?.id.toString() ===
            equipment.id.toString() && equipmentAssigned?.principal === true
      ) || []
    ).length > 0;
    positionSources?.models.forEach(renderPath);
    lastCoordinateModel = getMostRecentCoordinate(positionSources);
    equipmentType = isEquipmentAssignedAndIsPrincipal
      ? 'PRINCIPAL_EQUIPMENT'
      : 'SECONDARY_EQUIPMENT';
  } else {
    const firstPositionSource = positionSources.at(0);
    if ( !firstPositionSource ) return;
    renderPath(firstPositionSource, 0);
    lastCoordinateModel = firstPositionSource.get('coordinates').last();
    equipmentType = 'SECONDARY_EQUIPMENT';
  }
  
  Greenmile.RouteDetail.Util.addTruckMarkerToMap(
    lastCoordinateModel,
    screen.equipments[equipment.id],
    screen,
    equipmentType
  );
};
